import { CanActivateFn, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { BackstrapService } from '../shared/services/backstrap.service';


@Injectable({ providedIn: 'root'})
 export class PermissionsService {

 constructor(private backstrap: BackstrapService, private router: Router) { }

  async canActivate(): Promise<boolean> {
    let tkn = localStorage.getItem('oss-api-token');
    let proceed = false;
    if (tkn != null) {
      try {
        let res = await this.backstrap.checkToken();
        proceed = res;
      }
      catch(err) {
        proceed = false;
      }
    }

    if(!proceed) {
      this.router.navigate(['auth', 'sign-in']);
    }
    return proceed;
  }

 }


export const authGuard: CanActivateFn = async (route, state) => {
  return await inject(PermissionsService).canActivate();
};

